<template>
  <admin-layout>
    <template slot="content">
      <header-for-list-component
          sectionName="Funcionários"
          :items="admins"
          :totalItems="totalItems"
          :totalPages="totalPages"
          :itemsPerPage="itemsPerPage"
          :pageNumber.sync="pageNumber"
          @loadPage="loadPage($event)"
      />

      <v-layout
          align-center
          justify-space-between
          class="mb-3"
      >
        <v-flex xs4>
          <v-text-field
              v-model="search"
              solo
              label="Buscar por Funcionário"
              prepend-inner-icon="mdi-magnify"
              hide-details
              :loading="loadingSearch"
              @input="typing()"
          >
            <template v-slot:progress>
              <v-progress-linear
                  v-if="loadingSearch"
                  color="accent"
                  indeterminate
                  height="3"
              ></v-progress-linear>
            </template>
          </v-text-field>
        </v-flex>
        <v-spacer></v-spacer>
        <v-flex
            xs4
            class="text-xs-right">
          <create-or-update
              mode="create"
              :admin="null"
              @loadPage="loadPage(pageNumber)"
          ></create-or-update>

        </v-flex>
      </v-layout>
      <v-layout column>
        <v-data-table
            :headers="headers"
            :items="admins"
            hide-actions
            class="elevation-1">
          <template slot="items" slot-scope="props">
            <td>{{ props.item.id }}</td>
            <td>{{ props.item.name }}</td>
            <td class="text-xs-center">{{ cpf.format(props.item.cpf) }}</td>
            <td>{{ props.item.email }}</td>
            <td>
              <v-icon> mdi-{{ props.item.enabled ? 'checkbox-marked' : 'checkbox-blank-outline' }}</v-icon>
            </td>
            <td>
              <v-icon> mdi-{{ props.item.can_access_web ? 'checkbox-marked' : 'checkbox-blank-outline' }}</v-icon>
            </td>
            <td>
              <v-layout row>

                <create-or-update
                    mode="edit"
                    :admin="Object.assign({}, props.item)"
                    @loadPage="loadPage(pageNumber)">
                </create-or-update>

                <send-reset-password-instruction :admin="props.item"/>

              </v-layout>
            </td>
          </template>
        </v-data-table>
      </v-layout>
    </template>
  </admin-layout>
</template>

<script>
import AdminLayout from '@/layouts/AdminLayout';
import HeaderForListComponent from '@/components/configurations/HeaderForListComponent';
import AdminService from '@/services/applications/configurations/AdminService';

import CreateOrUpdate from '@/components/configurations/admins/CreateOrUpdate';
import SendResetPasswordInstruction from '@/components/configurations/admins/SendResetPasswordInstruction';

import * as cpf from "@fnando/cpf";
export default {
  name: 'List',
  components: {
    AdminLayout,
    HeaderForListComponent,
    CreateOrUpdate,
    SendResetPasswordInstruction,
  },
  mounted() {
    this.loadPage(1);
  },
  data() {
    return {
      cpf,
      search: '',
      admins: [],
      loadingSearch: false,
      interval: null,
      totalItems: 0,
      totalPages: 0,
      itemsPerPage: 20,
      pageNumber: 1,
      headers: [
        { text: 'ID', value: 'id', sortable: false, align: 'center' },
        { text: 'Nome', value: 'name', sortable: false, align: 'center' },
        { text: 'CPF', value: 'cpf', sortable: false, align: 'center' },
        { text: 'E-mail', value: 'email', sortable: false, align: 'center' },
        { text: 'Ativo', value: 'enabled', sortable: false, align: 'center' },
        { text: 'Acesso Web', value: 'can_access_web', sortable: false, align: 'center' },
        { text: 'Ações', value: '', sortable: false, align: 'center' }],
    };
  },
  methods: {
    loadPage(pageNumber) {
      this.pageNumber = pageNumber || this.pageNumber;
      if (!this.loadingSearch) this.$store.dispatch('setLoadingDialog', true);
      AdminService
        .all({
          page: this.pageNumber,
          q: this.search,
        })
        .then(({ data }) => {
          this.admins = data.admins || [];
          this.totalItems = data.total;
          this.totalPages = data.total_pages;
        })
        .finally(() => {
          this.$store.dispatch('setLoadingDialog', false);
          this.loadingSearch = false;
        });
    },
    typing() {
      clearInterval(this.interval)
      this.interval = setTimeout(() => {
        this.loadingSearch = true;
        this.pageNumber = 1;
        this.loadPage();
      }, 500);
    },
  },
};
</script>

<style scoped lang="scss">
</style>
